import React from 'react';
import { FaCalendar, FaHome } from 'react-icons/fa';

const ProgramDetailsView = ({ program }) => {
  if (!program) return null;

  return (
    <div className="program-details">
      {/* <h1>{program.program}</h1>
      <h3>{program.title}</h3> */}
      <h3>{program.info}</h3>
      <div className="total-info">
        <div className="quick-info">
          <div className="icon"><FaHome /></div>
          <div className="info">
            <h3>Faculty</h3>
            <p>{program.faculty}</p>
          </div>
        </div>
        <div className="quick-info">
          <div className="icon"><FaCalendar /></div>
          <div className="info">
            <h3>Expected Duration</h3>
            <p>{program.duration}</p>
          </div>
        </div>
      </div>
      <h1 style={{ marginTop: '40px' }}>Program Details</h1>
      <div className="details">
        <div className="detail">
          <p><b>Expected Duration</b>: {program.duration}</p>
          <p style={{ marginTop: '15px' }}>{program.details}</p>
          <h3 style={{ marginTop: '15px' }}>Curriculum</h3>
          <p>{program.curriculum}</p>
        </div>
        {program.imageURL && <img src={program.imageURL} alt={program.program} />}
      </div>
      <h1 style={{ marginTop: '40px' }}>Admission Requirements</h1>
      <p style={{ marginTop: '20px' }}>Note that meeting these requirements does not guarantee acceptance into the program.</p>
    </div>
  );
};

export default ProgramDetailsView;
